// DS1.7.12
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../Popover/Preset/TextTooltipOnHover';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import s from './TierStateBadges.scss';
const TierStateBadges = ({ deviation , showNeedCoreState , showPendingDeletionState , className  })=>{
    var _deviation_tier, _deviation_tier1, _deviation_tier2, _deviation_tier3;
    const { t  } = useTranslation();
    const { isOwner , isUserSubscribed  } = useSubscriptionTier(deviation);
    const canPublish = (_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.canUserPublish;
    const needCoreToPublish = isOwner && ((_deviation_tier1 = deviation.tier) === null || _deviation_tier1 === void 0 ? void 0 : _deviation_tier1.state) === 'draft' && !canPublish; // currently the only reason the owner cant publish
    let label;
    let tooltipText;
    let badgeClassName;
    if (((_deviation_tier2 = deviation.tier) === null || _deviation_tier2 === void 0 ? void 0 : _deviation_tier2.state) === 'draft') {
        tooltipText = t('deviationview.tierCard.stateBadge.tooltip.draft');
        label = t('deviationview.tierCard.stateBadge.label.draft');
        badgeClassName = 'draft';
    } else if (((_deviation_tier3 = deviation.tier) === null || _deviation_tier3 === void 0 ? void 0 : _deviation_tier3.state) === 'pending_deletion' && showPendingDeletionState) {
        label = t('deviationview.tierCard.stateBadge.label.pendingDeletion');
        tooltipText = t('deviationview.tierCard.stateBadge.tooltip.pendingDeletion.visitor');
        if (isOwner) {
            tooltipText = t('deviationview.tierCard.stateBadge.tooltip.pendingDeletion.owner');
        } else if (isUserSubscribed) {
            tooltipText = t('deviationview.tierCard.stateBadge.tooltip.pendingDeletion.subscriber');
        }
        badgeClassName = 'pending-deletion';
    }
    if (!label) {
        // because typescript is not always smart enough
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
        tooltipText: tooltipText
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['badge'], s[badgeClassName])
    }, label)), showNeedCoreState && needCoreToPublish && /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
        tooltipText: t('deviationview.tierCard.stateBadge.tooltip.needCore')
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['badge'], s['need-core'])
    }, t('deviationview.tierCard.stateBadge.label.needCore'))));
};
TierStateBadges.displayName = 'TierStateBadges';
export default TierStateBadges;
